import svgIcon from './components/svg-icon.vue';

export default svgIcon;
